export const DATE_FORMAT = 'MMM_DD_YYYY';

export const IS_GREATER_THAN = 'is_greater_than';

export const IS_LESS_THAN = 'is_less_than';

export const IS_EXACTLY = 'is_exactly';

export const IS_NOT_EXACTLY = 'is_not_exactly';

export const IS = 'is';

export const IS_NOT = 'is_not';

export const IS_BETWEEN = 'is_between';

export const IS_UNKNOWN = 'is_unknown';

export const HAS_ANY_VALUE = 'has_any_value';

export const CONTAINS = 'contains';

export const NOT_CONTAINS = 'not_contains';

export const STARTS_WITH = 'starts_with';

export const NOT_STARTS_WITH = 'not_starts_with';

export const ENDS_WITH = 'ends_with';

export const NOT_ENDS_WITH = 'not_ends_with';

export const REGEX = 'regex';

export const IS_TRUE = 'is_true';

export const IS_FALSE = 'is_false';

export const IS_EXACTLY_DAYS_AGO = 'is_exactly_days_ago';

export const IS_MORE_THAN_DAYS_AGO = 'is_more_than_days_ago';

export const IS_LESS_THAN_DAYS_AGO = 'is_less_than_days_ago';

export const IS_ON = 'is_on';

export const IS_AFTER = 'is_after';

export const IS_BEFORE = 'is_before';

export const AND = 'and';

export const FROM = 'from';

export const TO = 'to';

export const LAST = 'last';

export const ALL = 'all';
